import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import hamburgerIcon from '../assets/images/ham.svg';
import closeIcon from '../assets/images/close.svg';
import emailjs from 'emailjs-com'; // Import EmailJS

const Contact = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [statusMessage, setStatusMessage] = useState('');

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatusMessage('Sending...');

    // Use EmailJS to send the form data
    emailjs
      .send(
        'service_9xa0v2v', // Your service ID
        'template_4u0gjub', // Your template ID
        formData, // Send form data
        'prem' // Replace with your user ID
      )
      .then(
        (response) => {
          setStatusMessage('Message sent successfully!');
          setFormData({
            name: '',
            email: '',
            phone: '',
            message: ''
          });
        },
        (error) => {
          setStatusMessage('Failed to send message. Please try again later.');
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {/* Only show the close button when the sidebar is open */}
          {isSidebarOpen && (
            <img
              src={closeIcon}
              alt="Close Sidebar"
              className="close-btn"
              onClick={closeSidebar}
            />
          )}
        </div>
        <ul className="sidebar-links">
          <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
          <li><Link to="/about" onClick={closeSidebar}>About</Link></li>
          <li><Link to="/skills" onClick={closeSidebar}>Skills</Link></li>
          <li><Link to="/projects" onClick={closeSidebar}>Projects</Link></li>
          <li><Link to="/contact" onClick={closeSidebar}>Contact</Link></li>
        </ul>
      </div>

      {/* Hamburger Menu - Show only when the sidebar is closed */}
      {!isSidebarOpen && (
        <img
          src={hamburgerIcon}
          alt="Open Sidebar"
          className="hamburger"
          onClick={toggleSidebar}
        />
      )}

      {/* Header Section */}
      <header>
        <nav className="navbar">
          <div className="left">
            <Link to="/" className="portfolio-link">
              <span className="purple">P</span>rem Portfolio
            </Link>
          </div>
          <div className="right ml-auto">
            <ul className="navbar-nav">
              <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/skills">Skills</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/projects">Projects</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
            </ul>
          </div>
        </nav>
      </header>

      {/* Contact Section */}
      <section className="contact-section">
        <h1>Contact Me</h1>
        <p>If you have any questions, feel free to reach out using the form below.</p>

        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter your name"
            required
          />

          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter your email"
            required
          />

          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="Enter your phone number"
            required
          />

          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Your message"
            required
          ></textarea>

          <button type="submit" className="submit-btn">Send Message</button>
        </form>

        {statusMessage && <p>{statusMessage}</p>}
      </section>

      {/* Footer Section */}
      <footer>
        <div className="footer">
          <div className="first">
            <h3>Prem's Developer Portfolio</h3>
            <p>Building innovative solutions for the web, one project at a time.</p>
          </div>
          <div className="second">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/skills">Skills</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="third">
            <h4>Connect with me:</h4>
            <ul>
              <li>
                <a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-github"></i> GitHub
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </a>
              </li>
              <li>
                <a href="mailto:prempawar241@gmail.com">
                  <i className="fas fa-envelope"></i> Email Me
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-rights">
          <p className="mb-0">&copy; 2025 Prem's Portfolio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
